module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"massRemaining":"Refillable mass"},"de":{"massRemaining":"Auffüllbare Masse"},"fr":{"massRemaining":"Masse restante"},"it":{"massRemaining":"Massa residua"}}')
  delete Component.options._Ctor
}
